import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import routes from "../routes";

const AuthContext = createContext();
const apiUrl = process.env.REACT_APP_API_URL;

const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [token, setToken] = useState(localStorage.getItem("token") || "");
	const navigate = useNavigate();

	const logout = () => {
		setUser(null);
		setToken("");
		localStorage.removeItem("token");
		navigate(routes.login);
	};

	useEffect(() => {
		const token = localStorage.getItem("token");

		if (token) {
			setToken(token);
			fetchUserInfoFromAPI(token)
				.then(setUser)
				.catch(() => logout());
		} else {
			logout();
		}
	}, []);

	const fetchUserInfoFromAPI = async (token) => {
		return fetch(apiUrl + "user", {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => response.json())
			.catch((error) => {
				console.error("Error fetching user info:", error);
				throw error;
			});
	};

	const login = (token, user) => {
		localStorage.setItem("token", token);
		setToken(token);
		if (user) setUser(user);
		else
			fetchUserInfoFromAPI(token)
				.then(setUser)
				.catch(() => logout());
		navigate(routes.home);
	};

	return (
		<AuthContext.Provider value={{ token, user, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};

export default AuthProvider;

export const useAuth = () => {
	return useContext(AuthContext);
};
